import {
    Box,
    Text,
} from "@chakra-ui/react";

import {
    FileText,
    ArrowRight,
} from "lucide-react";

const PolicyCard = ({
    policy,
    onClick,
}) => {
    return (
        <Box
            bg="white"
            p={6}
            borderRadius="20px"
            border="1px solid"
            borderColor="gray.100"
            cursor="pointer"
            transition=".2s"
            onClick={onClick}
            _hover={{
                transform:
                    "translateY(-3px)",
                shadow: "md",
            }}
        >
            <FileText
                size={30}
                color="#2453FF"
            />

            <Text
                mt={5}
                fontSize="lg"
                fontWeight="700"
                color="#071D54"
            >
                {policy.title}
            </Text>

            <Text
                mt={3}
                color="gray.500"
                noOfLines={3}
            >
                Updated{" "}
                {new Date(
                    policy.updated_at
                ).toLocaleDateString(
                    "en-BW",
                    {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                    }
                )}
            </Text>

            <Text
                mt={5}
                color="#2453FF"
                fontWeight="600"
                display="flex"
                alignItems="center"
                gap={2}
            >
                View Document

                <ArrowRight
                    size={16}
                />
            </Text>
        </Box>
    );
};

export default PolicyCard;